<div class="container p-sm-0">
  <div class="row">
    @for (content of items; track trackByMasonryColumn($index, content)) {
      <div class="col-12 col-md-6 col-lg-4" wlAutomationId="masonry-column">
        @for (item of content; track trackByMasonryItem($index, item)) {
          <wl-masonry-card [item]="item"></wl-masonry-card>
        }
      </div>
    }
  </div>
</div>
